/** 설치형 첫 실행 부트스트랩 API — /api/setup/* (BFF → chat-server self-lock). install-bootstrap Part B. */
import { apiClient } from './client';

export type SetupStep = 'institution' | 'superadmin' | 'done';
export interface SetupStatus {
  needsSetup: boolean;
  step: SetupStep;
}

export async function getSetupStatus(): Promise<SetupStatus> {
  const { data } = await apiClient.get<SetupStatus>('/setup/status');
  return data;
}

export interface InstitutionSetupPayload {
  name: string;
  businessRegNo: string;
  domain?: string | null;
  representativeName?: string | null;
  businessType?: string | null;
  businessItem?: string | null;
  postalCode?: string | null;
  address?: string | null;
  addressDetail?: string | null;
  phone?: string | null;
  fax?: string | null;
  companyEmail?: string | null;
}

function tokenHeader(token?: string) {
  return token && token.length > 0 ? { headers: { 'x-setup-token': token } } : undefined;
}

export async function setupInstitution(
  payload: InstitutionSetupPayload,
  token?: string,
): Promise<{ institutionId: string; code: string }> {
  const { data } = await apiClient.post<{ institutionId: string; code: string }>('/setup/institution', payload, tokenHeader(token));
  return data;
}

export interface AdminSetupPayload {
  email: string;
  name: string;
  password: string;
  phone?: string | null;
}

export async function setupAdmin(payload: AdminSetupPayload, token?: string): Promise<{ ok: boolean }> {
  const { data } = await apiClient.post<{ ok: boolean }>('/setup/admin', payload, tokenHeader(token));
  return data;
}
